/**
 * Registry central de paths internos del frontend.
 * - Valores string: paths estáticos (usar directo).
 * - Funciones: builders para paths con params.
 *
 * Los strings referenciados también desde la tabla DB `menu_items` no deben
 * cambiar sin una migración coordinada. Preservan typos históricos.
 *
 * `paths.relative.*` agrupa los paths con `..` que React Router resuelve contra
 * la URL actual. Mantienen el comportamiento contextual original.
 */

const paths = {
  root: '/',
  login: '/login',
  administrador: '/administrador',
  constructorPdf: '/constructorPdf',
  // Ley 21.719: autoservicio del titular. Existe para los 5 userTypes, porque
  // cualquiera con cuenta puede ejercer sus derechos sobre sus propios datos.
  misDatos: '/mis-datos',

  admin: {
    root: '/admin',
    panelOperacional: '/admin/panel-operacional',
    tecnicos: '/admin/tecnicos',
    ciclo: '/admin/ciclo',
    hallazgos: '/admin/hallazgos',
    users: '/admin/users',
    tenants: '/admin/tenants',
    administradores: '/admin/administradores',
    solicitudesDatos: '/admin/solicitudes-datos',
    folders: '/admin/folders',
    maintanceReports: '/admin/maintanceReports',

    budget: {
      root: '/admin/budget',
    },
    odt: {
      gantt: (idOrder) => `/admin/odt/${idOrder}/gantt`,
    },
    client: {
      root: '/admin/client',
      datos: (id) => `/admin/client/${id}/datos`,
    },
    clientes: {
      detail: (id) => `/admin/clientes/${id}`,
    },
    certificacion: {
      root: '/admin/certificacion',
      nueva: '/admin/certificacion/nueva',
      detail: (id) => `/admin/certificacion/${id}`,
    },
    colecciones: {
      root: '/admin/colecciones',
      detail: (id) => `/admin/colecciones/${id}`,
      items: (id, itemId) => `/admin/colecciones/${id}/items/${itemId}`,
    },
    mantenciones: {
      root: '/admin/mantenciones',
      detail: (id) => `/admin/mantenciones/${id}`,
      calendario: '/admin/mantenciones/calendario',
      actividades: '/admin/mantenciones/actividades',
    },
    maintance: {
      root: '/admin/maintance',
      asignations: '/admin/maintance/asignations',
      categories: '/admin/maintance/categories',
    },
    presupuestos: {
      documentos: (id) => `/admin/presupuestos/${id}/documentos`,
    },
    documentComposer: (id, tipoDocumento) => `/admin/document-composer/${id}/${tipoDocumento}`,
  },

  specialist: {
    root: '/specialist',
    attentionVoucher: '/specialist/AttentionVoucher',
    test: '/specialist/test',
    order: {
      root: '/specialist/order',
      detail: (id) => `/specialist/order/${id}`,
      finishForm: (id) => `/specialist/order/${id}/finish-form`,
    },
    maintanceReports: {
      root: '/specialist/maintanceReports',
      detail: (id) => `/specialist/maintanceReports/${id}`,
      finishForm: (id) => `/specialist/maintanceReports/${id}/finish-form`,
    },
    mantenciones: {
      detail: (id) => `/specialist/mantenciones/${id}`,
    },
    solicitudes: {
      iniciar: (id) => `/specialist/solicitudes/${id}/iniciar`,
    },
    listaMantenciones: {
      root: '/specialist/lista-mantenciones',
      detail: (idMantencion) => `/specialist/lista-mantenciones/${idMantencion}`,
    },
    edificios: {
      root: '/specialist/edificios',
      detail: (id) => `/specialist/edificios/${id}`,
    },
  },

  tenants: {
    detail: (id) => `/tenants/${id}`,
    usuarios: (id) => `/tenants/${id}/usuarios`,
  },

  liftlogic: {
    menuItems: '/liftlogic/menu-items',
  },

  tenantResources: {
    menuItems: (tenantId) => `/admin/tenants/${tenantId}/menu-items`,
    pdfTemplates: (tenantId) => `/admin/tenants/${tenantId}/pdf-templates`,
    garantias: (tenantId) => `/admin/tenants/${tenantId}/garantias`,
    componentTemplates: (tenantId) => `/admin/tenants/${tenantId}/component-templates`,
    componentAttributeDefs: (tenantId) => `/admin/tenants/${tenantId}/component-attribute-defs`,
    componentTypes: (tenantId) => `/admin/tenants/${tenantId}/component-types`,
    equipos: (tenantId) => `/admin/tenants/${tenantId}/equipos`,
    equipoComponents: (tenantId, equipoId) =>
      `/admin/tenants/${tenantId}/ascensores/${equipoId}/components`,
  },

  pdfTemplates: {
    editor: (documentType) => `/pdf-templates/${documentType}`,
  },

  relative: {
    admin: {
      budget: '../admin/budget',
      certificacion: '../admin/certificacion',
    },
    specialist: {
      root: '../specialist/',
      order: '../specialist/order',
      orderDetail: (id) => `../specialist/order/${id}`,
      orderFinishForm: (id) => `../specialist/order/${id}/finish-form`,
      maintanceReports: '../specialist/MaintanceReports',
      maintanceReportDetail: (id) => `../specialist/MaintanceReports/${id}`,
    },
  },
};

export default paths;
